import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import ToolActionButtons, { ToolModeToggle } from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import {  EscapeText,  UnescapeText } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function EscapeUnescape() {
    const [text, setText] = useState("");
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'Escape/Unescape', Iconpath: "/FileCodeRaw.svg" };
    const [activeAction, setActiveAction] = useState("JAVASCRIPT");
    const [mode, setMode] = useState("escape");
    const formatTypes = ["JAVASCRIPT", "JAVA", "HTML", "SQL"];


    

    


    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const handleChange = (e) => {
        setText(e.target.value);
        if (mode === "escape") {
            Escape(e.target.value);
        } else {
            Unescape(e.target.value);
        }
    };

    const Escape = async (input) => {
        try {
            const payload = {
                "input": input,
                "type": activeAction
            }
            const response = await EscapeText(payload);
            setresult(response.data.output);
        }
        catch (error) {
            console.error("Error converting case:", error);
        }
    }

     const Unescape = async (input) => {
        try {
            const payload = {
                "input": input,
                "type": activeAction
            }
            const response = await UnescapeText(payload);
            setresult(response.data.output);
        }
        catch (error) {
            console.error("Error converting case:", error);
        }
    }

    const handleImport = (filecontent) => {
        setText(filecontent);
    };

    const runAction = async (action) => {
        setActiveAction(action);
        setText("");
        setresult("");
    }

    
    return (
        <>
            <Col>
                <ToolHeader title="Escape/Unescape" toolFav={toolFav} />
                <ToolModeToggle
                    options={[
                        { label: "Escape", value: "escape", className: "encode" },
                        { label: "Unescape", value: "unescape", className: "decode" }
                    ]}
                    activeValue={mode}
                    onChange={setMode}
                />
                <ToolActionButtons
                    actions={formatTypes}
                    activeValue={activeAction}
                    onAction={runAction}
                />


                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title={mode === "escape" ? "Input (RAW)" : "Input (Escaped)"}
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter text here..."
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".json"
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title={mode === "escape" ? "Output (Escaped)" : "Output (RAW)"}
                            value={result ?? ""}
                            placeholder="output will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.json"
                                    mimeType="application/json;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default EscapeUnescape;
